
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-card :loading="loading">
            <v-alert v-if="error" type="error">{{error}}</v-alert>
            <v-container>
              <v-card-title>
                Kunden von {{ app.name }}
                <div class="flex-grow-1"></div>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Suche" single-line></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-data-table
                        :headers="headers"
                        :items="list"
                        :search="search"
                        :items-per-page="50"
                        class="elevation-1"
                      >
                        <template v-slot:item.edit="{item}">
                          <v-btn small @click="editCustomer(item.id)">Bearbeiten</v-btn>
                        </template>
                        <template v-slot:item.invoices="{item}">
                          <v-btn small color="primary" @click="openInvoices(item.id)">  <v-icon left>mdi-file-document</v-icon> Öffnen</v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn color="primary" @click="addCustomer">Kunde hinzufügen</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AppService from "@/services/AppService";
import CustomerSerivce from "@/services/CustomerService";
import Header from "@/views/general/header";
import router from "@/plugins/router";

export default {
  name: "dashboard",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    error: null,
    app: {},
    list: [
      {
        name: "Test App",
        street: "Test",
        housenumber: "",
        zip: "123",
        city: "asd",
        phone: "asd",
        email: "asd"
      }
    ],
    search: null,
    headers: [
      { text: "#", value: "id", sotable: true, align: "left" },
      { text: "Name", value: "name", sotable: true, align: "left" },
      { text: "E-Mail", value: "email", sotable: true, align: "left" },
      { text: "Tel.", value: "phone", sotable: true, align: "left" },
      { text: "Straße", value: "street", sotable: true, align: "left" },
      { text: "PLZ", value: "zip", sotable: true, align: "left" },
      { text: "Stadt", value: "city", sotable: true, align: "left" },
      { text: "Bearbeiten", value: "edit", sotable: false, align: "left" },
      { text: "Abrechnungen", value: "invoices", sotable: false, align: "left" }
    ]
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    addCustomer() {
      router.push({
        name: "CustomersAdd",
        params: { id: this.$route.params.id }
      });
    },
    editCustomer(id) {
      router.push({
        name: "CustomersEdit",
        params: { appId: this.$route.params.id, id: id }
      });
    },
    openInvoices(id) {
      router.push({
        name: "CustomersInvoices",
        params: { appId: this.$route.params.id, customerId: id }
      });
    },
    async refresh() {
      this.loading = true;
      try {
        let data = (await AppService.getApp(this.$route.params.id)).data;
        if (data) {
          this.app = data;
        } else {
          this.app = { name: "APP NICHT GEFUNDEN" };
          router.replace("/apps");
        }

        data = (await CustomerSerivce.get(this.app.id)).data;
        if (data) {
          this.list = data;
        } else {
          this.list = [];
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.error = err.message;
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

